import { Box, Card, Grid, Stack, Typography } from "@compass/core";
import { ReportOutputFormats, Select } from "components";
import "moment-timezone";

import { ReportSelection, ReportType } from "./StudentReportPage";

export const StudentReportType = (props: {
  reportTypes: ReportSelection[];
  selectedReportType: ReportType | undefined;
  setSelectedReportType: (value: React.SetStateAction<ReportType | undefined>) => void;
  nscAccount?: string;
  nscOrganization?: string;
}) => {
  const isNscSelected = props.selectedReportType === "National Student Clearinghouse Request";

  return (
    <Card>
      <Grid container spacing="sm" alignItems="center">
        <Grid item xs={isNscSelected ? 4 : 4}>
          <Select
            label="Report Type"
            required
            value={props.reportTypes.find((x) => x.name === props.selectedReportType)}
            options={props.reportTypes}
            getOptionLabel={(option) => option.name}
            onChange={(e, value) => props.setSelectedReportType(value?.name)}
            renderOption={(props, option) => (
              <Box component="li" {...props}>
                <Stack
                  position="relative"
                  direction="row"
                  spacing="md"
                  alignItems={"center"}
                  justifyContent="space-between"
                  width="100%"
                >
                  <Typography>{option.name}</Typography>
                  <ReportOutputFormats formats={option.generateTypes} />
                </Stack>
              </Box>
            )}
          />
        </Grid>

        {isNscSelected && (
          <>
            <Grid item xs={4}>
              <Stack spacing="sm">
                <Typography variant="caption" color="text.secondary">
                  NSC Account
                </Typography>
                <Typography>{props.nscAccount || "N/A"}</Typography>
              </Stack>
            </Grid>

            <Grid item xs={4}>
              <Stack spacing="sm">
                <Typography variant="caption" color="text.secondary">
                  NSC Organization
                </Typography>
                <Typography>{props.nscOrganization || "N/A"}</Typography>
              </Stack>
            </Grid>
          </>
        )}
      </Grid>
    </Card>
  );
};
